export default "__VITE_ASSET__Ba4L3tM4__"